/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import Clickable from '../../../components/clickable/Clickable';
import Modal from '../../../components/modal';
import FileSlider from '../../../components/photoCarousel/FileSlider';
import Collapsible from '../../../components/collapsible/Collapsible';
import styles from './attachments.module.scss';

const AttachmentDetail = ({ attachments, title, extra_data, field, intl, displayLink, adp, noBorder, enabled_zoomed }) => {
  const [modal, setModal] = useState(false);
  const [initialSlide, setInitialSlide] = useState();

  const openPhotoModal = (idx) => {
    setModal(true);
    setInitialSlide(idx);
  };
  return (
      <>
        {attachments.length === 0 && adp && title
       && <div style={{ padding: '18px 16px', border: '1px solid #E6EAEE' }}>
            <span className={styles.title}>
              {title}
            </span>
          </div>
        }
        {attachments.length > 0 && !displayLink && (
        <div className={`${styles.requestInfoField} ${noBorder && styles.noBorder}`}>
          {title && (
            <span className={styles.title}>
              {title}
            </span>
          )}
          {attachments.length > 1 ? (
            <div className={styles.photos}>
              {attachments?.map((e, idx) => (
                <Clickable
                  key={e?.id}
                  onClick={() => openPhotoModal(idx)}
                >
                  {(e?.type || e?.content_type)?.includes('image') ? (
                    <img src={e?.preview || e?.url} alt={e?.file_name || e?.name} />
                  ) : <p>{e?.file_name || e?.name}</p>
                    }
                </Clickable>
              ))}
            </div>
          )
          :(
            <div className={styles.photo}>
              {attachments.map((e, idx) => (
                <Clickable
                  key={e?.id}
                  onClick={() => openPhotoModal(idx)}
                >
                  {(e?.type || e?.content_type)?.includes('image') ? (
                    <img src={e?.url} alt={e?.file_name || e?.name} />
                  ) : <p>{e?.file_name || e?.name}</p>
                  }
                </Clickable>
              ))}
            </div>
          )}
          {field?.enable_badge_scan && !Array.isArray(extra_data) && Object.keys(extra_data)?.length > 0 && (
            <Collapsible
              title="View Details"
              styleClasses={styles.viewDetails}
            >
              {Object.keys(extra_data)?.map(ef => (
                <>
                  <span>
                    {intl.formatMessage({ id: `extra_fields.forms.${ef}`, defaultMessage: ef?.toUpperCase() })}:
                    <p style={{ color: 'black' }}>&nbsp;&nbsp;{extra_data?.[ef]}</p>
                  </span>
                </>
              ))}
            </Collapsible>
          )}
          {field?.enable_badge_scan && Array.isArray(extra_data) && extra_data?.length > 0 && (
            <div>
              {extra_data?.map(badge => (
                <Collapsible
                  title="View Details"
                  styleClasses={styles.viewDetails}
                >
                  {badge && Object.keys(badge)?.map(ef => (
                    <>
                      <span>
                        {intl.formatMessage({ id: `extra_fields.forms.${ef}`, defaultMessage: ef?.toUpperCase() })}:
                        <p style={{ color: 'black' }}>&nbsp;&nbsp;{badge?.[ef]}</p>
                      </span>
                    </>
                  ))}
                </Collapsible>
              ))}
            </div>
          )}
        </div>
        )}
        {displayLink && attachments.length > 0 && (
          <Clickable
            onClick={() => openPhotoModal(0)}
            className={styles.link}
          >
            <FormattedMessage defaultMessage="View Uploads" id="flow.detail.view_uploads" tagName="p" />
          </Clickable>
        )}
        {attachments.length > 0 && (
          <Modal
            showIn={modal}
            onClose={() => setModal(false)}
            contentStyles={{
              overflow: 'visible',
              background: '#E6EAEE',
              padding: '20px 40px'
            }}
          >
            <div>
              {attachments.length > 0 && (
                <FileSlider photos={attachments} initialSlide={initialSlide} formsDetails={enabled_zoomed} />
              )}
            </div>
          </Modal>
        )}
      </>
  );
};

AttachmentDetail.propTypes = {
  attachments: PropTypes.shape([]),
  id: PropTypes.string.isRequired
};

AttachmentDetail.defaultProps = {
  attachments: []
};

export default injectIntl(AttachmentDetail);
